import {
  CountryList,
  SalesChannel,
  TotalAnnualSales,
} from "client/lib/apt-merchant";
import hasInstoreChannel from "client/utils/hasInstoreChannel";

export default function isEligibleForSelfServeInStore({
  multiTerminal,
  registeredCountry,
  salesChannel,
}: {
  multiTerminal?: string;
  registeredCountry?: CountryList;
  salesChannel?: SalesChannel;
  totalAnnualSales?: TotalAnnualSales;
}): boolean {
  const eligibleCountries: CountryList[] = ["United States", "Australia"];
  if (eligibleCountries.includes(registeredCountry as CountryList)) {
    return hasInstoreChannel(salesChannel) && multiTerminal === "No";
  }

  return false;
}

export const showMultiTerminalField = (salesChannel?: SalesChannel): boolean =>
  hasInstoreChannel(salesChannel);
